import { types, actions } from './requests'
export const DELETECONTRACT_TYPES = {
    ...types('DELETECONTRACT'),
}
export const DELETECONTRACT_ACTIONS = {
    ...actions('DELETECONTRACT'),
}
